var exports = {
  "E": "StaticDiffPreview__IxbmBd",
  "B": "HeaderContainer__RrFpP8",
};

module.exports = exports;
